/**
 * Whether an audience card offers "Add to collection". A collection holds only
 * the org's own audiences (D15), and only ready ones are worth adding.
 */
export function canAddAudienceToCollection(params: {
  audienceOrganizationToken?: string
  viewerOrganizationToken?: string | null
  status?: string
}): boolean {
  const { audienceOrganizationToken, viewerOrganizationToken, status } = params
  if (!viewerOrganizationToken || audienceOrganizationToken !== viewerOrganizationToken) {
    return false
  }
  return status !== 'error' && status !== 'processing'
}
